var _a;
import { Emergency, EmergencyFilled } from 'shared/assets/icons';
import { riskLevels } from './ehrNoteEnums';
/**  takes enums and add labels/icons/color. */
export var riskLevelRender = (_a = {},
    _a[riskLevels.notApplicable] = {
        label: 'Not Applicable',
        icon: null,
        color: 'gray.700',
        emphasis: 'medium-emphasis',
        colorScheme: 'neutral',
    },
    _a[riskLevels.notElevated] = {
        label: 'Risk Not Elevated',
        icon: null,
        color: 'gray.700',
        emphasis: 'medium-emphasis',
        colorScheme: 'neutral',
    },
    _a[riskLevels.high] = {
        label: 'High Risk',
        icon: EmergencyFilled,
        color: 'red.500',
        emphasis: 'medium-emphasis',
        colorScheme: 'negative',
    },
    _a[riskLevels.medium] = {
        label: 'Medium Risk',
        icon: Emergency,
        color: 'orange.500',
        emphasis: 'medium-emphasis',
        colorScheme: 'warning',
    },
    _a[riskLevels.low] = {
        label: 'Low Risk',
        icon: null,
        color: 'blue.700',
        emphasis: 'medium-emphasis',
        colorScheme: 'neutral',
    },
    _a);
export var riskSequence = [
    riskLevels.notApplicable,
    riskLevels.notElevated,
    riskLevels.low,
    riskLevels.medium,
    riskLevels.high,
];
export var getHighestRisk = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var highestIndex = 0;
    if (args.every(function (a) { return typeof a === 'undefined'; })) {
        return null;
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var riskLevel = args_1[_a];
        if (typeof riskLevel === 'undefined') {
            continue;
        }
        var currentIndex = riskSequence.indexOf(riskLevel);
        if (currentIndex > highestIndex) {
            highestIndex = currentIndex;
        }
    }
    return riskSequence[highestIndex];
};
